import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Spin, Empty, Typography } from 'antd';
import Sortable from 'react-sortablejs';

import CreativeSelect from '../../../containers/campaign/CreativeSelect';
import CreativeSingle from '../../../containers/campaign/CreativeSingle';

const CpCheckinsForm = ({
  handleRemoveCpCheckin,
  handleMoveCpCheckin,
  handleSubmit,
  submitting,
  loading,
  cpCheckinList,
}) => (
  <div>
    {cpCheckinList.length ? (
      <Row type="flex" align="top">
        <Col>
          <Typography.Title level={2}>CP Checkin</Typography.Title>
        </Col>
        <Col offset={1}>
          <CreativeSelect
            activeList={cpCheckinList}
            handleSubmit={handleSubmit}
            loading={submitting}
            multiple
          />
        </Col>
      </Row>
    ) : null}

    <Spin spinning={loading}>
      {!cpCheckinList.length && (
        <Empty description="No CP Checkins">
          <CreativeSelect handleSubmit={handleSubmit} loading={submitting} multiple />
        </Empty>
      )}

      {!cpCheckinList.length ? null : (
        <form onSubmit={handleSubmit} style={{ padding: 20, backgroundColor: '#E7E7E7' }}>
          <Sortable
            options={{
              animation: 150,
              swapThreshold: 0.65,
            }}
            onChange={handleMoveCpCheckin}
          >
            {cpCheckinList.map((cpCheckin, index) => (
              <CreativeSingle
                key={cpCheckin.action_media_id}
                removeCreative={() => handleRemoveCpCheckin(index)}
                creative={cpCheckin}
                creative_id={cpCheckin.action_media_id}
              />
            ))}
          </Sortable>

          <Row
            type="flex"
            align="middle"
            justify="space-between"
            className="grayRow"
            style={{ backgroundColor: 'transparent' }}
          >
            <Col span={24}>
              <div style={{ textAlign: 'right' }}>
                <Button type="primary" size="large" loading={submitting} onClick={handleSubmit}>
                  Update
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      )}
    </Spin>
  </div>
);

const optionShape = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })
);

const cpCheckinShape = PropTypes.arrayOf(
  PropTypes.shape({
    action_media_id: PropTypes.number,
    action_id: PropTypes.number,
    type: PropTypes.number,
    url: PropTypes.string,
    priority: PropTypes.number,
    rate_type: PropTypes.string,
    budget: PropTypes.number,
    expire_interval: PropTypes.object,
    advertiser_ad_id: PropTypes.number,
  })
);

CpCheckinsForm.propTypes = {
  handleRemoveCpCheckin: PropTypes.func.isRequired,
  handleMoveCpCheckin: PropTypes.func.isRequired,
  uploadPrefix: PropTypes.string.isRequired,
  cpCheckinList: cpCheckinShape.isRequired,
  pacingTypes: optionShape.isRequired,
  ruleOptions: optionShape.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default CpCheckinsForm;
